import { GlobalConstants } from "../../data/GlobalConstants";
import { handleResponse } from "../../util/functions";
import { getToken } from "../../helpers/helperJWT";
import { loaderService } from "../loaderService";

const url = GlobalConstants.urlApi;

const getProductos = (data) => {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/productos/getProductos`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const getPreciosMaestrosProductos = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/productos/getPreciosMaestrosProductos`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const getProductosNombres = (data) => {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/productos/getProductosNombres`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const getCategorizacion = () => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify()
    };

    return fetch(`${url}/unoauno/productos/getCategorizacion`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const validarExcelProductos = (data) => {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify({data})
    };

    return fetch(`${url}/unoauno/productos/validarExcelProductos`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const validarExcelCategoriasMarcas = ({data, file}) => {
    loaderService.showLoader({ label: "Cargando..." });

    const formData = new FormData();

    formData.append('data', JSON.stringify(data));
    formData.append('xls', file);

    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': getToken()
        },
        body: formData
    };

    return fetch(`${url}/unoauno/productos/validarExcelCategoriasMarcas`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const validarExcelPalabrasClave = ({data, file}) => {
    loaderService.showLoader({ label: "Cargando..." });

    const formData = new FormData();

    formData.append('data', JSON.stringify(data));
    formData.append('xls', file);

    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': getToken()
        },
        body: formData
    };

    return fetch(`${url}/unoauno/productos/validarExcelPalabrasClave`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const validarExcelDescripcion = ({data, file}) => {
    loaderService.showLoader({ label: "Cargando..." });

    const formData = new FormData();

    formData.append('data', JSON.stringify(data));
    formData.append('xls', file);

    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': getToken()
        },
        body: formData
    };

    return fetch(`${url}/unoauno/productos/validarExcelDescripcion`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const validarExcelEliminar = ({data, file}) => {
    loaderService.showLoader({ label: "Cargando..." });

    const formData = new FormData();

    formData.append('data', JSON.stringify(data));
    formData.append('xls', file);

    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': getToken()
        },
        body: formData
    };

    return fetch(`${url}/unoauno/productos/validarExcelEliminar`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const saveCargueExcel = ({data, file}) => {
    loaderService.showLoader({ label: "Cargando..." });
    
    const formData = new FormData();

    formData.append('data', JSON.stringify(data));
    formData.append('xls', file);

    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': getToken()
        },
        body: formData
    };

    return fetch(`${url}/unoauno/productos/saveCargueExcel`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const saveImageGeneralProducto = ({file, idProducto, idProveedor, nombreImg}) => {
    loaderService.showLoader({ label: "Cargando..." });
    
    const formData = new FormData();

    formData.append('idProducto', idProducto.toString());
    formData.append('idProveedor', idProveedor);
    formData.append('extension', "/productos");
    formData.append('nombreImg', nombreImg);
    formData.append('img', file);

    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': getToken()
        },
        body: formData
    };

    return fetch(`${url}/unoauno/productos/saveImageGeneralProducto`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const saveImageNutricionalProducto = ({file, idProducto, idProveedor, nombreImg}) => {
    loaderService.showLoader({ label: "Cargando..." });
    
    const formData = new FormData();

    formData.append('idProducto', idProducto.toString());
    formData.append('idProveedor', idProveedor);
    formData.append('extension', "/productos");
    formData.append('nombreImg', nombreImg);
    formData.append('img', file);

    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': getToken()
        },
        body: formData
    };

    return fetch(`${url}/unoauno/productos/saveImageNutricionalProducto`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const getFullProducto = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/productos/getFullProducto`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const getCategorizacionProducto = (data) => {
    loaderService.showLoader({ label: "Cargando..." });
    
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/productos/getCategorizacionProducto`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const getPalabrasClaveProducto = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/productos/getPalabrasClaveProducto`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const updateInformacionBasicaGeneral = (data) => {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/productos/updateInformacionBasicaGeneral`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const updateInformacionBasicaEspecifica = (data) => {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/productos/updateInformacionBasicaEspecifica`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const updateCategorizacionProducto = (data) => {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/productos/updateCategorizacionProducto`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const updateRestriccionesGeneralProducto = (data) => {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/productos/updateRestriccionesGeneralProducto`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const updateRestriccionesEspecificaProducto = (data) => {
    loaderService.showLoader({ label: "Cargando..." });
    
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/productos/updateRestriccionesEspecificaProducto`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

export const productosService = {
    getProductos,
    getPreciosMaestrosProductos,
    getProductosNombres,
    getCategorizacion,
    validarExcelProductos,
    validarExcelCategoriasMarcas,
    validarExcelPalabrasClave,
    validarExcelDescripcion,
    validarExcelEliminar,
    saveCargueExcel,
    saveImageGeneralProducto,
    saveImageNutricionalProducto,
    getFullProducto,
    getCategorizacionProducto,
    getPalabrasClaveProducto,
    updateInformacionBasicaGeneral,
    updateInformacionBasicaEspecifica,
    updateCategorizacionProducto,
    updateRestriccionesGeneralProducto,
    updateRestriccionesEspecificaProducto
};